import Vue from 'vue'

export var userData = {}
export var ipRetrieved = false
export var ipServiceEndpoint = 'https://api.ipify.org?format=json'

export function resetUserData () {
  userData = {}
  return userData
}

export function identify (username, email) {
  Object.assign(userData, {
    username,
    '$email': email,
    '$name': username
  })

  Vue.mixpanel.people.set(username, userData)
}

export function getIp () {
  return new Promise((resolve, reject) => {
    if (ipRetrieved) {
      resolve(userData)
    } else {
      ipRetrieved = true
      Vue.http.get(ipServiceEndpoint).then((response) => response.json()).then((ipData) => {
        ipRetrieved = true
        userData['$ip'] = ipData.ip
        resolve(userData)
      }).catch((e) => {
        reject(e)
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/mixpanel.js